import React, { memo } from 'react'
import ControlledSelect from 'transfix-form/components/ControlledSelect'
import { FormIf } from 'transfix-form/components/FormIf'
import Grid from 'transfix-ui/core/Grid'
import { IEquipmentTypes } from 'types/graphqlTypes'
import {
  EQUIPMENT_OPTIONS,
  EQUIPMENT_TYPE_OPTIONS,
} from 'apps/marketplace/utils/constants/graphqlEquipment'
import { useCreateShipmentFormContext } from '../../../context'
import { getErrorMessage } from '../../../utils/formErrorUtils'

export interface IControlledEquipmentSelectProps {}

const ControlledEquipmentSelect = memo<IControlledEquipmentSelectProps>(() => {
  /**
   * Form Context
   */
  const { control, errors } = useCreateShipmentFormContext()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <ControlledSelect
          control={control}
          name='equipment'
          SelectProps={{
            label: 'Equipment',
            dataTest: 'equipment-field',
            options: EQUIPMENT_OPTIONS,
            error: !!getErrorMessage(errors, 'equipment'),
            validationMessage: getErrorMessage(errors, 'equipment'),
            required: true,
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormIf control={control} name='equipment' when={IEquipmentTypes.dry_van}>
          <ControlledSelect
            control={control}
            name='equipmentType'
            SelectProps={{
              label: 'Equipment Type',
              dataTest: 'equipment-type-field',
              options: EQUIPMENT_TYPE_OPTIONS.dry_van,
              error: !!getErrorMessage(errors, 'equipmentType'),
              validationMessage: getErrorMessage(errors, 'equipmentType'),
              required: true,
            }}
          />
        </FormIf>
        <FormIf control={control} name='equipment' when={IEquipmentTypes.reefer}>
          <ControlledSelect
            control={control}
            name='equipmentType'
            SelectProps={{
              label: 'Equipment Type',
              dataTest: 'equipment-type-field',
              options: EQUIPMENT_TYPE_OPTIONS.reefer,
              error: !!getErrorMessage(errors, 'equipmentType'),
              validationMessage: getErrorMessage(errors, 'equipmentType'),
              required: true,
            }}
          />
        </FormIf>
        <FormIf control={control} name='equipment' when={IEquipmentTypes.open_deck}>
          <ControlledSelect
            control={control}
            name='equipmentType'
            SelectProps={{
              label: 'Equipment Type',
              dataTest: 'equipment-type-field',
              options: EQUIPMENT_TYPE_OPTIONS.open_deck,
              error: !!getErrorMessage(errors, 'equipmentType'),
              validationMessage: getErrorMessage(errors, 'equipmentType'),
              required: true,
            }}
          />
        </FormIf>
      </Grid>
    </Grid>
  )
})

export default ControlledEquipmentSelect
